import { InboxOutlined } from '@ant-design/icons';
import { App, AutoComplete, Button, Col, Divider, Form, Input, Row, Select, Upload } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../../../context/AuthProvider';
import { setPmAdditional, updateField } from '../../../../../contextRedux/PMAdditionalAct/PmAdditionalActModel';
import { RootState } from '../../../../../store';

const { Option } = AutoComplete;
const { Dragger } = Upload;
const CompanyDetailsTab: FC<any> = ({ form, fileList, setFileList }) => {
  const dispatch = useDispatch();
  const id = useSelector((state: RootState) => state?.models?.pmAdditionalAct?.id);
  const companyId = useSelector((state: RootState) => state?.models?.pmAdditionalAct?.companyId);

  const companies = useSelector((state: RootState) => state.store.company.data);
  const pmContractStatuses = useSelector((state: RootState) => state?.store.pmContractStatus.data);
  const pmOfferContractTypes = useSelector((state: RootState) => state?.store.pmOfferContractType.data);
  const accountSales = useSelector((state: RootState) => state?.store.user.data);
  const pmAdditionalAct = useSelector((state: RootState) => state?.models.pmAdditionalAct);
  const pmOffers = useSelector((state: RootState) => state.store.pmOffer.data);

  const [currentTotal, setCurrentTotal] = useState(0);
  const currentDate = moment().format('YYYY-MM-DD');
  const { profile } = useAuth();
  const { message } = App.useApp();

  const initialValues = {
    company: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.company),
    companyId: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.companyId),
    accountManager: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.accountManager),
    accountSale: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.accountSale),
    accountSaleId: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.accountSaleId),
    enumPmOfferContractTypeId: useSelector(
      (state: RootState) => state?.models?.pmAdditionalAct?.enumPmOfferContractTypeId
    ),
    enumPmOfferContractType: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.enumPmOfferContractType),
    enumPmContractStatusId: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.enumPmContractStatusId),
    enumPmContractStatus: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.enumPmContractStatus),
    date: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.date),
    dateStart: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.dateStart),
    dateEnd: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.dateEnd),
    remarks: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.remarks),
    registrationNumber: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.registrationNumber),
    pmContractIntervals: useSelector((state: RootState) => state?.models?.pmAdditionalAct?.pmContractIntervals),
    totalOfferValue:
      Number.parseFloat(
        (
          pmAdditionalAct.pmContractWorkPlaceItems?.reduce((total, item) => total + item.laborPrice, 0) +
          (pmAdditionalAct.pmContractLaborExtras
            ? pmAdditionalAct.pmContractLaborExtras?.reduce(
                (total: any, item: any) => total + item?.piece * item?.price,
                0
              )
            : 0)
        ).toFixed(2)
      ) +
      Number.parseFloat(
        pmAdditionalAct.pmContractWorkPlaceItems?.reduce((total, item) => {
          const totalPrice = item.price;
          return total + totalPrice;
        }, 0)
      ),
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const handleSelectClient = (value: any) => {
    const company = companies.find((company: any) => company.name === value?.label);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      company: company,
      companyId: company?.id,
      accountManager: company?.accountManager,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
    dispatch(updateField({ field: 'company', value: company ?? null }));
    dispatch(updateField({ field: 'accountManagerId', value: company?.accountManager?.id ?? null }));
    dispatch(updateField({ field: 'accountManager', value: company?.accountManager ?? null }));
  };

  const handleSelectAccountSales = (value: string) => {
    const accountSale = accountSales?.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      accountSale: accountSale,
      accountSaleId: accountSale?.id,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'accountSaleId', value: accountSale?.id ?? null }));
    dispatch(updateField({ field: 'accountSale', value: accountSale ?? null }));
  };

  const handleSelectStatus = (value: string) => {
    const selectStatus = pmContractStatuses.find((date) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumPmContractStatusId: selectStatus?.id,
      enumPmContractStatus: selectStatus,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumPmContractStatusId', value: selectStatus?.id ?? null }));
    dispatch(updateField({ field: 'enumPmContractStatus', value: selectStatus ?? null }));
  };

  const handleSelectType = (value: string) => {
    const selectedType = pmOfferContractTypes.find((type) => type.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumPmOfferContractTypeId: selectedType?.id,
      enumPmOfferContractType: selectedType,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumPmOfferContractTypeId', value: selectedType?.id ?? null }));
    dispatch(updateField({ field: 'enumPmOfferContractType', value: selectedType ?? null }));
  };

  const handleSelectClientOffer = (value: string) => {
    const pmOffer = pmOffers.find((o) => o?.number == value);
    dispatch(
      setPmAdditional({
        ...pmOffer,
        id: null,
        pmOfferId: pmOffer?.id,
        pmContractLaborExtras: pmOffer.pmOfferLaborExtras,
        pmContractWorkPlaceItems: pmOffer.pmOfferWorkPlaceItems,
      })
    );
  };

  const onDateChange = (dateField: string, dateValue: string) => {
    dispatch(updateField({ field: dateField, value: dateValue }));
    form.setFieldsValue({ [dateField]: dateValue });
  };

  const handleBlurClear = (fieldNames: string[]) => {
    fieldNames.forEach((field) => {
      form.setFieldsValue({ [field]: null });
      dispatch(updateField({ field, value: null }));
    });
  };

  const handlePriceChange = (value: number, index: number) => {
    const intervals = [...(pmAdditionalAct.pmContractIntervals || [])];
    intervals[index] = { ...intervals[index], price: value };
    calculateTotal(intervals);
  };

  const getCurrentIntervalPrice = () => {
    const total = form
      .getFieldValue('pmContractIntervals')
      ?.reduce((acc: number, cur: any) => acc + Number(cur?.price ?? 0), 0);
    return total ?? 0;
  };

  const handleRemove = (remove: Function, name: number) => {
    remove(name);
    const intervals = [...(form.getFieldValue('pmContractIntervals') || [])];
    intervals.splice(name, 1); // Remove the interval from the array
    calculateTotal(intervals);
  };

  const calculateTotal = (intervals: any[]) => {
    const total = (intervals || [])?.reduce((sum, interval) => sum + Number(interval?.price || 0), 0);
    setCurrentTotal(total);
  };

  const handleAddInterval = (add: Function) => {
    add();
  };

  const beforeUpload = (file: any) => {
    const isPdf = file.type === 'application/pdf';
    if (!isPdf) {
      message.error('You can only upload PDF files!');
      return Upload.LIST_IGNORE;
    }
    setFileList([file]);
    return false;
  };

  const handleRemoveFile = () => {
    setFileList([]);
  };

  useEffect(() => {
    form.setFieldValue('pmContractIntervals', pmAdditionalAct.pmContractIntervals);
  }, []);

  useEffect(() => {
    if (companyId) {
      const company = companies.find((company: any) => company.id === companyId);
      form.setFieldsValue({
        company: company,
        companyId: company?.id,
        accountManager: company?.accountManager,
      });

      dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
      dispatch(updateField({ field: 'company', value: company ?? null }));
      form.setFieldsValue({
        ...initialValues,
      });

      if (id == null || id == undefined || id == '') {
        handleSelectAccountSales(profile?.name!);
      }
    }
  }, [companyId]);

  useEffect(() => {
    if (id == null || id == undefined || id == '') {
      const currentDate = new Date().toISOString().split('T')[0];
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split('T')[0];

      form.setFieldsValue({
        enumPmContractStatus: { id: 1, name: 'Lead' },
        enumPmContractStatusId: 1,
        enumPmOfferContractType: { id: 2, name: 'Proiect' },
        enumPmOfferContractTypeId: 2,
        date: currentDate,
        dateStart: currentDate,
        dateEnd: formattedOneYearLater,
      });

      dispatch(updateField({ field: 'enumPmContractStatusId', value: 1 }));
      dispatch(updateField({ field: 'enumPmOfferContractTypeId', value: 2 }));
      dispatch(updateField({ field: 'date', value: currentDate }));
      dispatch(updateField({ field: 'dateStart', value: currentDate }));
      dispatch(updateField({ field: 'dateEnd', value: formattedOneYearLater }));
    }
  }, [id]);

  const remainingValue = initialValues.totalOfferValue - currentTotal;

  return (
    <Form
      form={form}
      initialValues={{ initialValues }}
      onValuesChange={handleFieldChange}
      layout='vertical'
      className='form-container'
    >
      {/* Selectati Client */}
      <Row gutter={[16, 1]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['company', 'name']}
            label='Selectati Client'
            rules={[{ required: true, message: 'Alegeti un client!' }]}
          >
            <Select
              disabled={!!id}
              showSearch
              placeholder='Search and select a client'
              optionFilterProp='label'
              onSelect={handleSelectClient}
              onChange={() => handleBlurClear(['company', 'companyId'])}
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              options={companies.map((company) => ({
                value: company.id,
                label: company.name || '',
              }))}
            />
          </Form.Item>
        </Col>

        {/* Account Manager */}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountManager', 'name']}
            label='Manager de cont'
            rules={[{ required: true, message: 'Alegeti un manager de cont!' }]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
        {/* Account Sale */}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountSale', 'name']}
            label='Agent Vanzari'
            rules={[{ required: true, message: 'Alegeti un agent de vanzari!' }]}
          >
            <AutoComplete
              disabled={true}
              options={accountSales.map((sale) => ({ value: sale.name }))}
              onSelect={handleSelectAccountSales}
              onChange={() => handleBlurClear(['accountSale', 'accountSaleId'])}
              filterOption={(input, option) => option?.value.toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>

        {/* Select Offer (Conditional) */}
        {(!id || id === '') && (
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item name={['offer', 'number']} label='Select Offer'>
              <AutoComplete onSelect={handleSelectClientOffer} disabled={true}>
                {pmOffers.map((offer: any, index: number) => (
                  <Option key={index} value={offer.number}>
                    {offer.number}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>
        )}

        {/* Status */}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['enumPmContractStatus', 'name']}
            label='Status'
            rules={[{ required: true, message: 'Alegeti un status!' }]}
          >
            <AutoComplete
              disabled={true}
              options={pmContractStatuses.map((status: any) => ({ value: status.name }))}
              onSelect={handleSelectStatus}
              onChange={() => handleBlurClear(['enumPmContractStatus', 'enumPmContractStatusId'])}
            />
          </Form.Item>
        </Col>
        {/* Contract Type */}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['enumPmOfferContractType', 'name']}
            label='Tip contract'
            rules={[{ required: true, message: 'Alegeti un tip oferta!' }]}
          >
            <AutoComplete
              disabled={true}
              options={pmOfferContractTypes.map((type: any) => ({ value: type.name }))}
              onSelect={handleSelectType}
              onChange={() => handleBlurClear(['enumPmOfferContractType', 'enumPmOfferContractTypeId'])}
            />
          </Form.Item>
        </Col>
        <Divider />
      </Row>
      {/* Contract Dates and Details */}
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Contract'
            name='date'
            rules={[{ required: true, message: 'Introduceti data contract!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('date', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Inceput'
            name='dateStart'
            rules={[{ required: true, message: 'Introduceti data inceput!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateStart', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Sfarsit'
            name='dateEnd'
            rules={[{ required: true, message: 'Introduceti data sfarsit!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateEnd', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Numar de Inregistrare'
            name='registrationNumber'
            rules={[{ required: true, message: 'Introduceti numarul de inregistrare!' }]}
          >
            <Input onChange={(e) => dispatch(updateField({ field: 'registrationNumber', value: e.target.value }))} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label='Observatii' name='remarks'>
            <TextArea />
          </Form.Item>
        </Col>
      </Row>

      <Divider />

      {/* Contract Intervals */}
      <Form.List name='pmContractIntervals'>
        {(fields, { add, remove }) => (
          <>
            {fields?.map(({ key, name, ...restField }, index) => (
              <Row key={key} gutter={16} style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    {...restField}
                    label='Data'
                    name={[name, 'date']}
                    rules={[{ required: true, message: 'Introduceti data!' }]}
                  >
                    <Input type='date' />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    {...restField}
                    label='Valoare'
                    name={[name, 'price']}
                    rules={[
                      { required: true, message: 'Introduceti pretul!' },
                      () => ({
                        validator(_, _value) {
                          const currentPrice = getCurrentIntervalPrice();
                          if (currentPrice <= initialValues.totalOfferValue) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(`Valoarea totală nu poate depăși ${initialValues.totalOfferValue}`)
                          );
                        },
                      }),
                    ]}
                  >
                    <Input
                      type='number'
                      min={0}
                      max={remainingValue + Number(getCurrentIntervalPrice())}
                      onChange={(e) => handlePriceChange(Number(e.target.value), index)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Button danger onClick={() => handleRemove(remove, name)}>
                    Sterge
                  </Button>
                </Col>
              </Row>
            ))}
            <Form.Item>
              <Button
                type='dashed'
                onClick={() => handleAddInterval(add)}
                block
                disabled={!(getCurrentIntervalPrice() <= initialValues.totalOfferValue)} // Disable if total equals or exceeds totalOfferValue
              >
                Adauga Incasare
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      {/* File Upload */}
      <Col xs={24}>
        <Dragger beforeUpload={beforeUpload} fileList={fileList} onRemove={handleRemoveFile} multiple={false}>
          <p className='ant-upload-drag-icon'>
            <InboxOutlined />
          </p>
          <p className='ant-upload-text'>Click sau plaseaza fisierul PDF pentru incarcare</p>
          <p className='ant-upload-hint'>Doar fisiere PDF.</p>
        </Dragger>
      </Col>
    </Form>
  );
};

export default CompanyDetailsTab;
